import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core'
import { EMAIL_SUPPORT } from '@ui-core/constants/app.constant'
import { AlertService } from '@ui-core/services/alert.service'
import { ButtonModule } from 'primeng/button'

@Component({
    selector: 'app-support',
    imports: [ButtonModule],
    templateUrl: './support.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class Support {
    emailSupport = input<string>(EMAIL_SUPPORT)

    private alertService = inject(AlertService)

    copyEmail() {
        navigator.clipboard.writeText(this.emailSupport()).then(() => {
            this.alertService.set({
                severity: 'success',
                summary: 'Success',
                detail: 'Email address copied to clipboard.',
                life: 3000
            })
        })
    }
}
